import {
  ACTIVATE_BOOKING_BY_QR_FAILED,
  ACTIVATE_BOOKING_BY_QR_LOADING,
  ACTIVATE_BOOKING_BY_QR_SUCCESS
  } from "../types"
  
  const initialState = {
    loading: false,
    error: false,
    message: null,
    bookingInfo: null,
  }
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case ACTIVATE_BOOKING_BY_QR_LOADING:
        return {
          ...state,
          loading: true,
          error: false,
          message: null,
          bookingInfo: null
        }
      case ACTIVATE_BOOKING_BY_QR_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          message: action.payload,
          bookingInfo: null
        }
      case ACTIVATE_BOOKING_BY_QR_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          message: null,
          bookingInfo: action.payload
        }
      default:
        return state
    }
  }
  